<template>
    <div id="gameFrame">
        <iframe src="/juego.html" name="gameIframe" scrolling="no" frameborder="0" 
        marginheight="0px" marginwidth="0px" height="100%" width="100%" allowfullscreen>
        </iframe>
    </div>
</template>
<style>
    #gameFrame {
        background-color: rgb(53, 53, 54);
        height: 100vh;
    }
    .vue-tempalte {
       background-color: rgb(53, 53, 54); 
    }
</style>
<script>
    
    export default {
        data() {
            return {}
        },
        methods: {},
        mounted: function() {
            document.title = "Descubre la Eurocidade con Chavín."
        }
    }
</script>